import React from 'react';
import { useParams } from 'react-router-dom';
import { Square, Stack } from '@grubhubprod/gh-cookbook-react';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { CreateReportFormProvider } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/CreateReportForm/CreateReportFormProvider';
import { CreateReportForm } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/CreateReportForm/CreateReportForm';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { buildCMUIPath, CMUIPage, getHomeBreadcrumb } from 'src/constants/urls';

export const CreateReportsPage: React.FC = () => {
  const { corpid: corpId } = useParams<{ corpid: string }>();

  return (
    <Square inset="lg">
      <Stack y="lg">
        <PageHeader>
          <PageTitle title="Create Reports" />
          <Breadcrumbs
            breadcrumbs={[
              {
                label: 'Admin home',
                ...getHomeBreadcrumb(corpId),
              },
              {
                label: 'Reports',
                href: buildCMUIPath(CMUIPage.REPORTS, { corpId }),
                useRouterLink: true,
              },
            ]}
          />
        </PageHeader>
        <CreateReportFormProvider>
          <CreateReportForm />
        </CreateReportFormProvider>
      </Stack>
    </Square>
  );
};
